<template>
	<div class="main" v-title data-title="零部件网站CAD数据使用条款">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<div class="barprebox bgwhite">
				<div class="mt25 ml20 txl">
					<div class="mt10 txc" style="border-bottom: 1px solid #ccc;">
						<h1 class="color1 font18 item1 txc">CAD数据使用条款</h1>
						<p class="txc pd20 font12">发布日期:2021.1.1</p>
					</div>
				</div>
				<div class="formWBase txl">
					<div class="list-item">
						<div class="noticeD ">
							<p class="fw">
								1、使用目的
							</p>
							<p>
								沐风网络科技有限公司（以下简称“本公司”）在本网站中提供的CAD数据（指3D CAD数据、3D CAD中间数据以及2D CAD数据），其目的是为了方便使用者在使用CAD的布局设计中，易于确认本公司或相关厂商产品（以下简称“产品”）的干涉、形状等条件而提供的。
							</p>
							<p class="fw">
								2 .数据的特性
							</p>
							<p>
								有关CAD数据中的公差、表面粗糙度、倒角等，可能会与实际产品的形状有所不同。另外，为了减轻CAD数据量并确保数据的稳定提供，部分产品的数据可能会省略了油槽形状或螺纹、弹簧形状等。请在事先理解的基础上使用。
							</p>
							<p>部分模型需要使用SolidWorks2018及以上版本才能使用，低版本无法保证全部能够正常使用，敬请谅解！</p>
							
							<p class="fw">
								3.免责条款
							</p>
							<p>
								本公司在制作CAD数据时虽然力求准确无误，但因上述数据特性，本公司不保证CAD数据的正确性。此外，本公司变更、添加或删除CAD数据时，恕不另行通知。无论理由如何，因CAD数据的使用、变更或删除而发生的任何损失，本公司概不负责。
							</p>
							
							<p class="fw">4.著作权</p>
							<p>CAD数据中所包含的所有信息的著作权，均归属本公司或本公司相关厂商所有。该著作权受著作权法以及国际条约的保护。未经本公司事先许可，不得将CAD数据用于上述以外用途（包括复制、修改、上传、发表、传送、公布、授权、销售、出版等）。</p>
							<p>违反上述目的和法律等而使用CAD数据时，本公司会禁止用户使用CAD数据和本公司的网站，并可能采取法律措施。</p>
							
							<p class="fw">5.第三方条款</p>
							<p>使用第三方（包括相关厂商）拥有权利的CAD数据或CAD数据编辑、浏览软件时，必须同意第三方规定的条款，否则可能无法使用CAD数据或软件。在此情况下，本公司对该第三方的CAD数据以及软件的瑕疵、侵权等不承担任何责任。敬请谅解。</p>
							
							<p class="fw">6.该规则的修订等</p>
							<p>1.）本公司可以修订，变更和修正本规则（以下简称“修订等”）。</p>
							<p>2.）本公司在对本规则进行修订等时，会在修订等的生效日前，通过沐风零部件网页“网站公告”的页面和其他适当的方法公布修订等的内容和生效日等其他必要事项。</p>
							<p>3.）本规则的修订等自公布中规定的生效日起适用。</p>
							<p class="fw">条款无效或协议排除时的处理</p>
							<p>如果本规则的某条款根据制定法，命令，规则等适用法律法规之规定无效或协议排除时，该条款只在遵守适用法律法规的必要范围内，被视为修改或删除。本规则其他的条款继续全面的有效。</p>
							<p>发布日期：2021年1月1日</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				noticeinfo: [],
				goods_id: ''
			};
		},
		created() {},
		methods: {

		}
	}
</script>

<style scoped>
	.list-item .noticeD {
		position: relative;
		padding: 10px 20px;
		font-size: 14px;
	}

	.list-item .noticeD p {
		font-size: 16px;
		color: #717171;
		font-weight: 400;
		line-height: 26px !important;
		margin: 0 0 16px;
		overflow-x: auto;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-divider {
		margin: 12px 0px;
	}

	.fw {
		font-weight: bold !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/notice/cadagreement.vue